import handleError from "../handleError";
import billingInstance from "../api-billing";
import providerInstance from "../api-provider";
import store from "../../redux/store";
import {
  setCountryCode,
  setPracticeTimezone,
} from "../../redux/reducers/practice";
import { setChatMessages } from "../../redux/reducers/aiChat";
import { setMicrophoneVerified } from "../../redux/reducers/dictation";

// export const login = async (email, password) => {
//   try {
//     // Logged In
//     let response = await instance({
//       url: "/auth/signin",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: {
//         email,
//         password,
//         returnSecureToken: true,
//       },
//     });
//     // let location = await getPracticeLocation(response.data.uuid);
//     // let doctorData = await getProviderListByAdmin(response.data.uuid);
//     // response.data["location"] = location.data;
//     // response.data["doctorData"] = doctorData.doctorList?.[0];
//     // response.data["userType"] = "provider";
//     if (typeof window !== "undefined") {
//       localStorage.setItem("auth_data", JSON.stringify(response.data));
//     }
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

export const providerLogin = async (email, password) => {
  try {
    let response = await providerInstance({
      url: "/auth/doLogin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email_id: email,
        password,
      },
    });
    // let location = await getPracticeLocation(response.data.uuid);
    // let doctorData = await getProviderListByAdmin(response.data.uuid);
    // response.data["location"] = location.data;
    // response.data["doctorData"] = doctorData.doctorList?.[0];
    // response.data["userType"] = "provider";
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(response.data));
    // }
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};
export const resetPassword = async (email, password, token) => {
  try {
    let response = await providerInstance({
      url: "/auth/resetPassword",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        emailId: email,
        isPermanent: true,
        password,
      },
    });

    return response.data;
  } catch (error) {
    handleError(error);
  }
};
export const sendCode = async (payload) => {
  try {
    let response = await providerInstance({
      url: "/auth/sendCode",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    // let location = await getPracticeLocation(response.data.uuid);
    // let doctorData = await getProviderListByAdmin(response.data.uuid);
    // response.data["location"] = location.data;
    // response.data["doctorData"] = doctorData.doctorList?.[0];
    // response.data["userType"] = "provider";
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(response.data));
    // }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
export const verifyCode = async (uniqueId, verificationCode, token) => {
  try {
    let response = await providerInstance({
      url: "/auth/verifyCode",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        uniqueId,
        verificationCode,
      },
    });
    // let location = await getPracticeLocation(response.data.uuid);
    // let doctorData = await getProviderListByAdmin(response.data.uuid);
    // response.data["location"] = location.data;
    // response.data["doctorData"] = doctorData.doctorList?.[0];
    // response.data["userType"] = "provider";
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(response.data));
    // }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const billingLogin = async (email, password) => {
  try {
    // Logged In
    let response = await billingInstance({
      url: "/auth/doLogin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email_id: email,
        password,
      },
    });
    // response.data.data["loginTime"] = new Date();
    // response.data.data["userType"] = "scribe";
    // response.data.data["email"] = email.toLowerCase();
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(response.data.data));
    // }
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};

export const billingRefreshToken = async (payload, token) => {
  try {
    const response = await billingInstance({
      url: "/auth/refreshToken",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    // const auth_data = await isAuthenticated();
    const { access_token, id_token } = response.data.data;
    // auth_data["loginTime"] = new Date();
    // auth_data["access_token"] = access_token;
    // auth_data["id_token"] = id_token;
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(auth_data));
    // }
    return { billing_access_token: access_token, billing_id_token: id_token };
  } catch (error) {
    console.log("ERROR WHILE SENDING REFRESH TOKEN: ", error);
    // dispatch(authFailed(error))
  }
};

export const providerRefreshToken = async (payload, token) => {
  try {
    const response = await providerInstance({
      url: "/auth/refreshToken",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    // const auth_data = await isAuthenticated();
    const { access_token, id_token } = response.data.data;
    // auth_data["loginTime"] = new Date();
    // auth_data["access_token"] = access_token;
    // auth_data["id_token"] = id_token;
    // if (typeof window !== "undefined") {
    //   localStorage.setItem("auth_data", JSON.stringify(auth_data));
    // }
    return { access_token, id_token };
  } catch (error) {
    console.log("ERROR WHILE SENDING REFRESH TOKEN: ", error);
    // dispatch(authFailed(error))
  }
};

export const logout = () => {
  const { dispatch } = store;
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("accuchart-logout"));
      localStorage.removeItem("auth_data");
      localStorage.removeItem("practice_timezone");
      localStorage.removeItem("microphoneVerifiedAt");
      dispatch(setPracticeTimezone("EST"));
      dispatch(setCountryCode("US"));
      dispatch(setChatMessages([]));
      dispatch(setMicrophoneVerified(null));
    }
  } catch (error) {
    console.log("error: ", error);
    if (typeof window !== "undefined") {
      localStorage.removeItem("auth_data");
      localStorage.removeItem("practice_timezone");
      localStorage.removeItem("microphoneVerifiedAt");
      dispatch(setPracticeTimezone("EST"));
      dispatch(setCountryCode("US"));
      dispatch(setChatMessages([]));
      dispatch(setMicrophoneVerified(null));
    }
  }
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("auth_data")) {
    const auth_data = JSON.parse(localStorage.getItem("auth_data"));
    if (new Date() - new Date(auth_data.loginTime) < 3600000) return auth_data;
    return null;
  } else {
    return false;
  }
};

export const locationUpdate = async (locationId, token) => {
  try {
    let localData = isAuthenticated();
    await providerInstance({
      url: `/auth/user/updateLocId/${localData.uuid}/${locationId}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    localData["current_practice_location_id"] = locationId;
    if (typeof window !== "undefined") {
      localStorage.setItem("auth_data", JSON.stringify(localData));
    }
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

// export const getProviderListByAdmin = async (uuid) => {
//   try {
//     // let uuid = isAuthenticated();
//     let response = await instance({
//       url: `/provider/getProviderListByAdmin`,
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: {
//         uuid,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

// export const getPracticeLocation = async (uuid) => {
//   try {
//     let response = await instance({
//       url: `/auth/user/pracLocations/${uuid}`,
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//     return response;
//   } catch (error) {
//     return "ERROR";
//   }
// };
